/**
 * "Aggiorna" dei report (finanziario e clienti): ricalcola davvero i mesi del periodo, anche quelli chiusi.
 * Il ricalcolo gira in coda: si legge l'avanzamento finche' non finisce, poi la pagina ricarica.
 *
 * Uso: mixins: [refreshMixin('finance')] oppure refreshMixin('customers'); la pagina ha `range` ({ from, to })
 * e il metodo `carica()`. Nel template: refreshing, refreshProgress (0-100), refreshLabel.
 */
const POLL_MS = 3000;
const POLL_LIMIT = 400; // 20 minuti

export const refreshMixin = kind => ({
	data() {
		return { refreshing: false, refreshDone: 0, refreshTotal: 0, refreshStartedAt: 0 };
	},
	computed: {
		refreshProgress() {
			return this.refreshTotal ? Math.round((this.refreshDone / this.refreshTotal) * 100) : 0;
		},
		refreshLabel() {
			if (!this.refreshing) return '';
			if (!this.refreshTotal) return 'Ricalcolo in coda…';
			return `Ricalcolo in corso: ${this.refreshDone} di ${this.refreshTotal}`;
		},
	},
	beforeDestroy() {
		clearTimeout(this.refreshTimer);
	},
	methods: {
		async aggiorna() {
			if (this.refreshing) return;
			this.refreshing = true;
			this.refreshDone = 0;
			this.refreshTotal = 0;
			this.refreshStartedAt = Date.now();
			try {
				await this.$store.dispatch('finance/startRefresh', { kind, from: this.range.from, to: this.range.to });
				this.refreshPoll(0);
			} catch (err) {
				this.refreshing = false;
				this.errore(err);
			}
		},
		refreshPoll(round) {
			this.refreshTimer = setTimeout(async () => {
				let status = null;
				try {
					status = await this.$store.dispatch('finance/refreshStatus', kind);
				} catch (err) {
					status = null;
				}
				// lo stato di un ricalcolo precedente non conta: si aspetta quello appena avviato
				const fresh = status && status.updatedAt && new Date(status.updatedAt).getTime() >= this.refreshStartedAt - 1000;
				if (fresh) {
					this.refreshDone = status.done || 0;
					this.refreshTotal = status.total || 0;
				}
				if (fresh && status.status === 'done') {
					this.refreshing = false;
					await this.carica();
					this.$store.dispatch('settings/updateSnackbar', { color: 'success', text: 'Report ricalcolato', snackbar: true, mode: 'multi-line', timeout: 4000 });
					return;
				}
				if (fresh && status.status === 'error') {
					this.refreshing = false;
					this.$store.dispatch('settings/updateSnackbar', { color: 'error', text: `Ricalcolo non riuscito: ${status.error || ''}`, snackbar: true, mode: 'multi-line', timeout: 6000 });
					return;
				}
				if (round < POLL_LIMIT) this.refreshPoll(round + 1);
				else this.refreshing = false;
			}, POLL_MS);
		},
	},
});
